import React from 'react';
import { Link } from 'react-router-dom';

const MyTests = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <Link to="/services/test-prep" className="text-blue-600 hover:text-blue-700 mb-4 inline-block">
          Back to Test Prep Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">My Tests</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">View your enrolled tests and progress</p>
          <p className="text-sm text-gray-500 mt-4">Detailed test progress tracking coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default MyTests;
